import { Component, Input } from '@angular/core';

@Component({
  selector: 'caceis-icon',
  templateUrl: './caceis-icon.component.html',
})
export class CaceisIconComponent {

  @Input() icon: CaceisIcons = CaceisIcons.estrela_fill;
  @Input() color: CaceisIconColors = CaceisIconColors.gray;
  @Input() isInputIcon: boolean = false;

}

export enum CaceisIconColors {
  red = "s-red",
  gray = "s-gray"
}

export enum CaceisIcons {
  duplicate = "icon-duplicate",
  email_at = "icon-email_at",
  estrela = "icon-estrela",
  estrela_fill = "icon-estrela_fill",
  hide = "icon-hide",
  lixo = "icon-lixo",
  lock = "icon-lock",
  minus1 = "icon-minus-1",
  on_off = "icon-on_off",
  pictureframe = "icon-pictureframe",
  plus = "icon-plus",
  profile = "icon-profile",
  pullup = "icon-pullup",
  search = "icon-search",
  show = "icon-show",
  sms = "icon-sms",
  switch = "icon-switch",
  warning1 = "icon-warning-1",
  write = "icon-write",
  x1 = "icon-x-1",
  pontos3 = "icon-3pontos",
  arrowleft = "icon-arrowleft",
  arrowright = "icon-arrowright",
  blocked = "icon-blocked",
  checkmark1 = "icon-checkmark-1",
  checkmark = "icon-checkmark",
  dropdown1 = "icon-dropdown-1",
  dropdown = "icon-dropdown",
  pause = "icon-pause",
  question = "icon-question",
  warning = "icon-warning",
  x = "icon-x",
  arrowdown_filled = "icon-arrowdown_filled",
  minus = "icon-minus",
  numeric_decrease = "icon-numeric_decrease",
  numeric_increase = "icon-numeric_increase",
  vector = "icon-vector",
  numeric_stable = "icon-numeric_stable",
  calendar = "icon-calendario"
}
